<template>
  <div>
    <b-row>
        <b-col>
          <b-row>
            <b-col :class="rightTable ? 'col-md-4' : 'col-md-2'">
              <AppSearchInput
                :label="$t('search') + ':'"
                :placeholder="$t('search') + '...'"
                @callback="search"
              />
            </b-col>

            <b-col class="col-md-6 ml-auto text-right">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-modal.modal-add-brigade
                class="mt-1"
                variant="primary"
                @click="editBrigade = {}"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="16"
                />
                {{$t('general.add')}}
              </b-button>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col>
              <!--  ==============================  TABLE_SECTION START ============================== -->
              <b-table
                :items="GET_BRIGADE.results"
                :fields="columns"
                show-empty
                hover
                responsive
                :empty-text="$t('empty_text')"
              >
                <!-- @row-clicked="onRowSelected" -->
                <template #head()="props">
                  <span>{{ $t(props.label) }}</span>
                </template>

                <template #cell(actions)="props">
                  <div class="d-flex align-items-center justify-content-end">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      v-b-modal.modal-add-brigade
                      size="sm"
                      class="mt-50 mb-50"
                      variant="warning"
                      @click="editTableRow(props.item)"
                    >
                      <feather-icon icon="EditIcon" size="15" />
                    </b-button>

                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      size="sm"
                      class="ml-1 mt-50 mb-50"
                      variant="danger"
                      @click="handleDelete(props)"
                    >
                      <feather-icon icon="TrashIcon" size="15" />
                    </b-button>
                  </div>
                </template>
              </b-table>
              <!--  ==============================  TABLE_SECTION END ============================== -->
              





              <!--  ==============================  PAGINATION_SECTION START ============================== -->
              <Pagination
                :nobody="nobody"
                :rows="GET_BRIGADE.count"
                :params="params"
                @refresh="refresh()"
              />
              <!--  ==============================  PAGINATION_SECTION END ============================== -->
            </b-col>
          </b-row>
        </b-col>


<!-- 
        <b-col v-show="rightTable">
          <pinWorks
          />
        </b-col> -->

    </b-row>


    <addEditModal :edit-brigade="editBrigade" />
  </div>
</template>

<script>
import {
  BButton,
  BRow,
  BCol,
  BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import AppSearchInput from '@/components/AppSearchInput.vue'
import areYouSure from '@/mixins/areYouSure'
import addEditModal from './addEditModal.vue'
import Pagination from '@/components/Pagination.vue'
import pinWorks from '@/views/modules/Reference/brigades/pinWorks.vue'

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BTable,
    AppSearchInput,
    addEditModal,
    Pagination,
    pinWorks,
  },
  directives: {
    Ripple,
  },
  mixins: [
    areYouSure,
  ],
  data() {
    return {



      // ===============  PRIMARY_DATA_SECTION START ===============
      rightTable: false,
      editBrigade: {},
      nobody: false,
      params: {
        search: "",
        page_size: 10,
        page: 1,
      },
      object: null,
      // ===============  PRIMARY_DATA_SECTION END ===============



      // ===============  OTHERS_SECTION START ===============
      columns: [
        {
          label: '№',
          key: 'id',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          label: 'namee',
          key: 'title',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'actions',
          key: 'actions',
          thClass: 'text-right',
          tdClass: 'text-right',
        },
      ],
      // ===============  OTHERS_SECTION END ===============



    }
  },
  computed: {
    ...mapGetters('brigade', ['GET_BRIGADE']),
    workTypeLoading: {
      get: function () {
        return this.$store.state.brigade.workTypeLoading;
      },
      set: function (newValue) {
        this.$store.commit('brigade/SET_BRIGADE_WORK_TYPE_LOADING', newValue)
      }
    },
  },
  async mounted() {


    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.refresh();
    // ===============  PRIMARY_REQUESTS_SECTION START ===============


  },
  methods: {
    ...mapActions('brigade', ['FETCH_BRIGADE', 'DELETE_BRIGADE', 'FETCH_ONE_BRIGADE']),
    ...mapActions('brigadeWorks', ['FETCH_ONE_BRIGADE_WORKS']),

    async refresh(){
      await this.FETCH_BRIGADE(this.params)
    },

    editTableRow(item){
      this.$route.params.editMode = true
      this.editBrigade = item
    },




    // ===============  DELETE_SECTION START ===============
    handleDelete(props) {
      this.$_showAreYouSureModal().then(val => {
          if (val) {
            this.DELETE_BRIGADE(props.item.id)
              .then(async () => {
                await this.refresh();
                this.$_okToast()
              })
              .catch(err => {
                this.$_errToast(err)
              });
          }
        });
    },
    // ===============  DELETE_SECTION END ===============




    


    // ===============  FILTER_SECTION START ===============
    async onRowSelected(item) {
      this.workTypeLoading = true
      this.$router.replace({ path: "/reference", query: { brigade_id: item.id } });

      await this.FETCH_ONE_BRIGADE({ id: item.id })
      .then(() => {
        this.$forceUpdate()
      })
      this.rightTable = true
      this.workTypeLoading = false
    },
    // ===============  FILTER_SECTION END ===============








    // ===============  SEARCH_SECTION START ===============
    async search(text) {
      this.params.search = text
      await this.refresh();
    },
    // ===============  SEARCH_SECTION END ===============




  },
}
</script>
